import { ImageContentFit } from 'expo-image';
import { SvgUri } from 'react-native-svg';
import { Image } from 'tamagui';

export const ImageOrSvg = ({
  uri,
  height,
  width,
  borderRadius,
  blurHash,
  fit,
  borderColor,
  borderWidth,
}: {
  uri: string;
  height: number;
  width?: number;
  borderRadius: number;
  blurHash?: string;
  fit?: ImageContentFit;
  borderColor?: string;
  borderWidth?: number;
}) => {
  const blurhashDefault =
    '|rF?hV%2WCj[ayj[a|j[az_NaeWBj@ayfRayfQfQM{M|azj[azf6fQfQfQIpWXofj[ayj[j[fQayWCoeoeaya}j[ayfQa{oLj?j[WVj[ayayj[fQoff7azayj[ayj[j[ayofayayayj[fQj[ayayj[ayfjj[j[ayjuayj[';
  const isSvg = uri.endsWith('.svg');
  if (isSvg) {
    return (
      <SvgUri
        width={width ?? '100%'}
        height={height}
        uri={uri}
        style={{
          // zIndex: -1,
          borderRadius: borderRadius,
          borderColor: borderColor,
          borderWidth: borderWidth,
        }}
      />
    );
  }

  return (
    <Image
      style={{
        height: height,
        // zIndex: -1,
        borderRadius: borderRadius,
        width: width ?? 'auto',
        borderColor: borderColor,
        borderWidth: borderWidth,
      }}
      objectFit={fit}
      // placeholder={blurHash ?? blurhashDefault}
      // transition={500}
      source={{ uri: uri }}
      
      // progressiveRenderingEnabled={true}
    />
  );
};
